/*============================================================================
  Native predictive search (Shopify Predictive Search API)
  Progressive-enhances the existing search forms, no markup changes required.
==============================================================================*/
(function () {
  var FORMS = 'form.search_form, form.search__form, form.header_search_form';
  var SECTION = 'predictive-search';
  var TYPES = 'product,collection,query,page,article';
  var MIN_CHARS = 3;
  var DELAY = 300;

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function setup(form) {
    if (form.dataset.predictiveBound) return;
    form.dataset.predictiveBound = 'true';

    var input = form.querySelector('input[name="q"]');
    if (!input) return;

    input.setAttribute('autocomplete', 'off');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');

    var panel = document.createElement('div');
    panel.className = 'predictive-search__panel';
    panel.id = 'predictive-search-panel-' + Math.random().toString(36).slice(2);
    panel.setAttribute('role', 'listbox');
    panel.hidden = true;
    input.setAttribute('aria-controls', panel.id);
    form.appendChild(panel);

    var controller = null;

    function close() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }

    function open() {
      if (panel.innerHTML.trim()) {
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }
    }

    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < MIN_CHARS) { panel.innerHTML = ''; close(); return; }

      if (controller) controller.abort();
      controller = new AbortController();

      var url = '/search/suggest?q=' + encodeURIComponent(q) +
                '&resources[type]=' + TYPES +
                '&resources[limit]=' + (window.PXUTheme && window.PXUTheme.theme_settings && window.PXUTheme.theme_settings.search_to_display || 5) +
                '&section_id=' + SECTION;

      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var section = doc.getElementById('shopify-section-' + SECTION) || doc.body;
          panel.innerHTML = section.innerHTML;
          open();
        })
        .catch(function (err) { if (err.name !== 'AbortError') close(); });
    }, DELAY);

    function links() { return panel.querySelectorAll('a'); }

    input.addEventListener('input', run);
    input.addEventListener('focus', open);
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); input.focus(); return; }
      if (panel.hidden) return;

      var items = links();
      if (!items.length) return;
      var current = document.activeElement;
      var idx = Array.prototype.indexOf.call(items, current);

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        (items[idx + 1] || items[0]).focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        (items[idx - 1] || items[items.length - 1]).focus();
      } else if (e.key === 'Enter' && current && current.tagName === 'A') {
        // let the focused suggestion link handle navigation
        window.location.href = current.href;
        e.preventDefault();
      }
    });
    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) close();
    });
  }

  function init() {
    var settings = window.PXUTheme && window.PXUTheme.theme_settings;
    if (settings && String(settings.enable_autocomplete).toLowerCase() === 'false') return;

    var forms = document.querySelectorAll(FORMS);
    for (var i = 0; i < forms.length; i++) setup(forms[i]);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  // Re-bind for sections re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
